import { useFirebase } from "api/FirebaseProvider";
import { Dashboard } from "model/Datatypes";
import { useEffect, useState } from "react";

export const useDashboards = (site: string) => {
  const [dashboards, setDashboards] = useState<null | Dashboard[]>(null);
  const fb = useFirebase();

  useEffect(() => {
    if (site) {
      fb.firestore()
        .collection("dashboardConfigurations")
        .where("site", "==", site)
        .get()
        .then((querySnap) => {
          const dashboards: Dashboard[] = [];
          querySnap.forEach((doc) => {
            dashboards.push(doc.data() as Dashboard);
          });
          setDashboards(dashboards);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.log("No site has been set");
    }
  }, [fb, site]);

  return { dashboards };
};
